import { createStore, sample } from 'effector'
import { goOnPrivateError } from '@/app/routing/events'
import { getUserProfileFx } from '@/entities/user'
import { XboxUserData } from './types.ts'

export const $xboxUserData = createStore<null | XboxUserData>(null).on(getUserProfileFx.doneData, (_, data) => {
  if (data.xbox_data == null && !data.user.xbox_update_in_progress) {
    sample({
      clock: $xboxUserData,
      filter: (xboxData) => xboxData === null,
      target: goOnPrivateError,
    })
  }
  if (!data.xbox_data) {
    return null
  }
  return {
    ...data?.xbox_data,
    xbox_gigi: data?.user?.xbox_gigi ?? 0,
    updating: data?.user?.xbox_update_in_progress ?? false,
  }
})
